import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getDebited, getWallet } from "../../../redux/wallet/action";
import {
  Commas,
  getDateFormate,
  maskAccountNumber,
} from "../../Common/AllDateTimeReleventFormate";
import BasicChartLineGraphforReport from "../../Common/Graphs/BasicChartLineGraphforReport";
import TimeWiseFilter from "../DashboardReports/GraphFilter/TimeWiseFilter";
import Pagination from "../../Modules/FindWork/SearchAll/AllPosts/CustomPagination/Pagination";
import { useStateContext } from "../../../Context/StateContext";
import CommonPagination from "../../Common/PaginationComponet/CommonPagination";
import { getPaymentType } from "../../../redux/common/action";
import { useTranslation } from "react-i18next";
import { urtoast } from "../../Layouts/CustomPopup/eventEmitter";

export default function DashboadWallet() {
  const [firstdate, setFirstdate] = useState("");
  const [lastdate, setLastdate] = useState("");
  const [type, setType] = useState(1);
  const { t } = useTranslation();

  const [searchtext, setSearchtext] = useState("");
  const [debouncedSearchtext, setDebouncedSearchtext] = useState(searchtext);

  const path = "Assets/scss/dashboard.module.scss";
  const [tab, setTab] = useState(1);
  const [trn, setTrn] = useState(0);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const wallet = useSelector(({ wallet: { walletlist } }) => walletlist);
  const debitlist = useSelector(({ wallet: { debitlist } }) => debitlist);

  const { state, setPageNumber } = useStateContext();
  const { pageNumber } = state;

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  // Debounce search input
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchtext(searchtext.trim());
    }, 500);

    return () => clearTimeout(handler);
  }, [searchtext]);

  // Fetch wallet or debit data
  useEffect(() => {
    if (tab == 1) {
      const data = {
        added_type: trn,
        searchtext: debouncedSearchtext,
        index: pageNumber,
      };
      dispatch(getWallet(data));
    } else if (tab == 2) {
      const data = {
        added_type: trn,
        searchtext: debouncedSearchtext,
        index: pageNumber,
      };
      dispatch(getDebited(data));
    }
  }, [tab, trn, dispatch, pageNumber, debouncedSearchtext]);

  const nav = () => {
    const state = {
      id: "",
      type_of_post: "wallet",
      auction_id: "",
      deposit_price: "",
      post_price: "",
    };
    navigate(`/${lan}/account/paymentmethodpage`, {
      state: { orderdetails: { ...state } },
    });
  };

  // Filter transactions based on search text
  const filteredTransactions = (tab == 2 ? debitlist?.history : wallet?.history);

  const navigatetowithdrawamount = () => {
    if (!wallet?.wallet || wallet?.wallet <= 0) {
      urtoast("Withdrawal amount must be greater than 0", 2);
      return;
    }
    navigate(`/${lan}/submitwithdrawamount`, {
      state: { wallet: wallet.wallet },
    });
  };

  return (
    <div className="wallet-sec">
      <h2 className="font-42">My Wallet</h2>

      <div className="row">
        <div
          className="col-md-4"
          onClick={() => {
            setTrn(0);
            setTab(1);
            setPageNumber(0);
            window.scrollTo(0, 650);
          }}
        >
          <div className="wallet-first">
            <div className="d-flex justify-content-between align-items-center">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/wallet-first.png`}
                alt=""
              />

            </div>
            <h6>Amount In Escrow</h6>
            <h2 className={wallet?.deposit < 0 ? "text-danger" : ""}>
              {wallet?.deposit !== 0 ? `$ ${Commas(wallet?.deposit)}` : "-"}
            </h2>
            <button className="buttons border-button"
            >
              <span>View Transactions</span>
            </button>
          </div>
        </div>
        <div
          className="col-md-8"
          onClick={() => {
            setTrn(0);
            setTab(2);
            setPageNumber(0);
            window.scrollTo(0, 650);
          }}
        >
          <div className="wallet-second d-flex justify-content-between align-items-center">
            <div className="wallet-left">
              <div className="d-flex justify-content-between align-items-center">
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/wallet-second.png`}
                  alt=""
                />

              </div>
              <h6>Available Balance</h6>
              <h2 className={wallet?.wallet < 0 ? "text-danger" : ""}>
                {wallet?.wallet !== 0 ? `$ ${Commas(wallet?.wallet)}` : "-"}
              </h2>
              <p>Wallet payment Security (WPS)</p>
              <p>
                Money is securely held for expert/buyer before starting the
                work and is released only after customer approval
              </p>
            </div>
            <div className="wallet-right">
              {wallet?.account_number && (
                <>
                  <p>Bank account</p>
                  <h6>{maskAccountNumber(wallet?.account_number)}</h6>
                  {wallet?.wallet ? (
                    <button
                      onClick={navigatetowithdrawamount}
                      className="buttons background-button"
                    >
                      <span>Withdraw amount</span>
                    </button>
                  ) : (
                    ""
                  )}
                </>
              )}
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setTrn(0);
                  setTab(2);
                  setPageNumber(0);
                  window.scrollTo(0, 650);
                }}
                className="buttons border-button"
                style={{ marginTop: "10px" }}
              >
                <span>View Transactions</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="graph-sec bg-white dashboard-padding wallet-calendar">
        <h4>{tab === 1 ? "Escrow Insight" : "Earning Insight"}</h4>
        <TimeWiseFilter
          setFirstdate={setFirstdate}
          setLastdate={setLastdate}
          setType={setType}
          start_date={firstdate}
          end_date={lastdate}
        />
        <BasicChartLineGraphforReport
          tab={tab}
          history={wallet?.insights}
          start_date={firstdate}
          end_date={lastdate}
          type={type}
        />
      </div>

      <div className="recent-transaction bg-white dashboard-padding">
        <div className="recent-first d-flex justify-content-between align-items-center ">
          <div className="d-flex align-items-center" style={{ gap: "24px" }}>
            <h4
              onClick={() => {
                setTab(1);
                setPageNumber(0);
              }}
              style={{
                cursor: "pointer",
                color: tab === 1 ? "#EF7710" : "#8D8D8D",
                borderBottom: tab === 1 ? "2px solid #EF7710" : "none",
                paddingBottom: "4px",
                fontSize: "24px"
              }}
            >
              Escrow Transactions
            </h4>
            <h4
              onClick={() => {
                setTab(2);
                setPageNumber(0);
              }}
              style={{
                cursor: "pointer",
                color: tab === 2 ? "#EF7710" : "#8D8D8D",
                borderBottom: tab === 2 ? "2px solid #EF7710" : "none",
                paddingBottom: "4px",
                fontSize: "24px"
              }}
            >
              Wallet Transactions
            </h4>
          </div>

          <div className="d-flex align-items-center recent-right">
            <div className="d-flex sort-by">
              <p>Sort by : </p>
              <select
                value={trn}
                onChange={(e) => setTrn(Number(e.target.value))}
              >
                <option value={0}>All</option>
                <option value={1}>Credited</option>
                <option value={2}>Debited</option>
              </select>
            </div>
          </div>
        </div>

        <div>
          <div className="form-group search-transaction">
            <label>Search Transaction</label>
            <div className="search-bar">
              <input
                type="text"
                className="form-control"
                onChange={(e) => setSearchtext(e.target.value)}
                placeholder="Search here"
              />
              <button className="btn search-btn">
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/common/search-lg.svg`}
                  alt=""
                />
              </button>
            </div>
          </div>
        </div>

        <div className="recent-table thead-table table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Transaction ID</th>
                <th>Date</th>
                <th>Type</th>
                {tab == 2 && (
                  <>
                    <th>Total Price</th>
                    <th>Commission</th>
                  </>
                )}
                <th>Amount</th>
                <th>Balance</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {filteredTransactions && filteredTransactions.length > 0 ? (
                filteredTransactions.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <div className="d-flex td-img">
                        <h6>#{item?.id}</h6>
                      </div>
                    </td>
                    <td>
                      <h6>{getDateFormate(item?.created_on)}</h6>
                    </td>
                    <td>
                      <h6 className="reason-text">{item?.reason}</h6>
                    </td>
                    {tab == 2 && (
                      <>
                        <td>
                          <h6>
                            {item?.added_type == 1 && Number(item?.total_price) ? `$ ${Commas(item?.total_price)}` : "-"}
                          </h6>
                        </td>
                        <td>
                          <h6>
                            {item?.added_type == 1 && Number(item?.commission_amount) ? `(${item?.commission_percent || 0}%) $ ${Commas(item?.commission_amount)}` : "-"}
                          </h6>
                        </td>
                      </>
                    )}
                    <td>
                      <h6 className={item?.added_type == 1 ? "text-success" : "text-danger"}>
                        {Number(item?.amount) ? (
                          <>
                            {item?.added_type == 1 ? "+" : "-"} $ {Commas(item?.amount)}
                          </>
                        ) : "-"}
                      </h6>
                    </td>
                    <td>
                      <h6>{Number(item?.updated_amount) ? `$ ${Commas(item?.updated_amount)}` : "-"}</h6>
                    </td>
                    <td>
                      {item?.added_type == 1 ? (
                        <span className="credit-debit credit">Credited</span>
                      ) : (
                        <span className="credit-debit debit">Debited</span>
                      )}
                    </td>
                  </tr>
                ))
              ) : debouncedSearchtext ? (
                <tr>
                  <td colSpan={8} style={{ textAlign: "center" }}>
                    No transactions found
                  </td>
                </tr>
              ) : (
                <tr>
                  <td colSpan={8} style={{ textAlign: "center" }}>
                    No transactions available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <CommonPagination
            totalitemcounts={(tab == 1 ? wallet : debitlist)?.count}
            size={20}
            pageNumber={state?.pageNumber}
            setPageNumber={setPageNumber}
          />
        </div>
      </div>
    </div>
  );
}
